export const getPublicIP = async () => {
	try {
		const response = await fetch('https://api.ipify.org?format=json');
		const data = await response.json();
		return data.ip;
	} catch (error) {
		console.warn('Failed to get public IP:', error);
		// Fallback to a default value or try another service
		try {
			const response = await fetch('https://ipapi.co/json/');
			const data = await response.json();
			return data.ip;
		} catch (fallbackError) {
			console.warn('Fallback IP service also failed:', fallbackError);
			return 'unknown';
		}
	}
};

export const checkGeolocationPermission = async () => {
	try {
		if (!navigator.permissions) {
			// Fallback for browsers that don't support Permissions API
			return 'unknown';
		}

		// Add 5-second timeout to permission check
		const timeoutPromise = new Promise((resolve) => {
			setTimeout(() => resolve('timeout'), 5000);
		});

		const permissionPromise = navigator.permissions.query({ name: 'geolocation' });

		const result = await Promise.race([permissionPromise, timeoutPromise]);

		if (result === 'timeout') {
			console.warn('Location permission check timed out after 5 seconds');
			return 'timeout';
		}

		return result.state;
	} catch (error) {
		console.warn('Error checking geolocation permission:', error);
		return 'unknown';
	}
};

export const getGeolocation = () =>
	new Promise((resolve) => {
		if (!navigator.geolocation) {
			console.warn('Geolocation is not supported by this browser');
			resolve({ latitude: null, longitude: null });
			return;
		}

		// Add a 5-second timeout wrapper
		const timeoutId = setTimeout(() => {
			console.warn('Geolocation request timed out after 5 seconds');
			resolve({ latitude: null, longitude: null });
		}, 5000);

		navigator.geolocation.getCurrentPosition(
			(position) => {
				clearTimeout(timeoutId);
				resolve({
					latitude: position.coords.latitude,
					longitude: position.coords.longitude,
				});
			},
			(error) => {
				clearTimeout(timeoutId);
				console.warn('Error getting geolocation:', error);
				resolve({ latitude: null, longitude: null });
			},
			{
				enableHighAccuracy: true,
				timeout: 5000, // Reduced from 10000 to match our wrapper timeout
				maximumAge: 300000, // 5 minutes
			}
		);
	});

export const getLoginHeaders = async () => {
	// Check geolocation permission first
	const permissionState = await checkGeolocationPermission();

	const [ip, geolocation] = await Promise.all([getPublicIP(), getGeolocation()]);

	return {
		ip,
		latitude: geolocation.latitude,
		longitude: geolocation.longitude,
		permissionState, // Include permission state for handling in UI
	};
};
